import { useCallback, useState } from "react";
import { Check, Copy } from "lucide-react";

interface CodeCopyButtonProps {
  value: string;
  variant?: "floating" | "inline";
}

export function CodeCopyButton({ value, variant = "floating" }: CodeCopyButtonProps) {
  const [copied, setCopied] = useState(false);

  const handleCopy = useCallback(async () => {
    try {
      await navigator.clipboard.writeText(value);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      // Clipboard API not available.
    }
  }, [value]);

  const positionClass =
    variant === "floating"
      ? "absolute right-2 top-2 z-10"
      : "relative z-0";

  return (
    <button
      type="button"
      onClick={handleCopy}
      className={`${positionClass} flex items-center gap-1.5 rounded-md bg-gray-100 px-2.5 py-1 text-xs font-medium text-gray-600 transition-colors hover:bg-gray-200 dark:bg-gray-700 dark:text-gray-300 dark:hover:bg-gray-600`}
    >
      {copied ? (
        <>
          <Check className="size-3.5" />
          Copied!
        </>
      ) : (
        <>
          <Copy className="size-3.5" />
          Copy
        </>
      )}
    </button>
  );
}
